import { cva } from '../tokens/variants';

export const emptyStateVariants = cva('flex flex-col items-center text-center mx-auto', {
  variants: {
    size: {
      sm: 'gap-2 max-w-sm py-6',
      md: 'gap-3 max-w-md py-10',
      lg: 'gap-4 max-w-xl py-16',
    },
  },
  defaultVariants: { size: 'md' },
});
